import { createContext, useContext } from 'react';

export const MobileDeviceContext = createContext();

export function useMobileDevice() {
  return useContext(MobileDeviceContext);
}
